import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import Contact from './components/Contact';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16 md:pt-18">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
        <BrandIntro />
        <Reputation />
        <Contact />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于嫩小兔',
            description: '嫩小兔是深受年轻人喜爱的萌系潮流品牌，汇聚嫩小兔系列周边、玩偶、联名产品与限定礼盒。',
            url: 'https://www.nenxiaotu.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '嫩小兔',
              url: 'https://www.nenxiaotu.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.nenxiaotu.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '嫩小兔玩偶可以机洗吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不建议机洗哦！我们推荐手洗保养：使用30℃温水和中性洗涤剂，轻轻按压清洗，不要用力揉搓或拧绞。洗后用干毛巾吸去多余水分，放在通风处自然晾干。避免暴晒、烘干和使用漂白剂。',
                },
              },
              {
                '@type': 'Question',
                name: '嫩小兔的产品材质安全吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '所有嫩小兔产品均通过国家玩具安全标准GB6675认证，采用环保安全面料和填充物，无毒无味，适合各个年龄段使用。',
                },
              },
              {
                '@type': 'Question',
                name: '嫩小兔有线下实体店吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '目前我们以线上官方商城为主，但会不定期在全国各大城市举办快闪店活动。关注我们的社交媒体账号，第一时间获取快闪店活动信息！',
                },
              },
              {
                '@type': 'Question',
                name: '如何辨别真假嫩小兔产品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '正品嫩小兔产品均配有专属防伪标签和唯一编码。可通过扫描防伪二维码验证，检查产品标签是否含有"嫩小兔"注册商标，注意玩偶做工细节。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}